export default function getLodgesForPlaceFactory(ajax) {
  return async function getLodgesForPlace({ placeId, limit, page }) {
    return await ajax({
      resource: `lodgings/lodges?place=${placeId}&per_page=${limit}&page=${page}&is_bookable=1`,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getLodgesForPlace.js